export interface FieldOperator {
  districtsLocations: string[];
  externalId: string;
  identifier: string;
  name: string;
  surname: string;
  userId: string;
}
